import { useParams, Link } from 'react-router-dom';
//import './../../Topics/Style/SubjectTopics.css';
import './../Style/MTNumber.css';
import MTYearNumber from './MTYearNumber';
import TopNavbar from '../../home/TopNavbar';
import TopHeader from '../../home/TopHeader';
import { useEffect, useState } from 'react';


function PYQMockTestYear() {
    const { type, subject, subjectName } = useParams();
    const [submisstion, setSubmissions] = useState([]);

    useEffect(() => {
        const saved = localStorage.getItem('quizSubmissions');
        const data = saved ? JSON.parse(saved) : [];
        setSubmissions(data);
    }, []);

    let subSubject;

    if (subject === 'math') {
        subSubject = "math";
    } else if (subject === 'physics') {
        subSubject = "phy";
    } else if (subject === 'chemistry') {
        subSubject = "che";
    } else {
        subSubject = "";
    }

    return (
        <div className="subject-topics-page">

            <TopNavbar name={subjectName + " Mock Test"} />
            <TopHeader name={subjectName + " Mock Test"} />


            <div className="topics-container">

                {MTYearNumber.map((quizNum, index) => {

                    const quizId = `${quizNum.year}${quizNum.month}${quizNum.day}${quizNum.type}${quizNum.shift}${subSubject}`;

                    const userSubmission = submisstion?.find(
                        submission => submission.quizId === quizId
                    );
                    const isUserQuiz = !!userSubmission;

                    const score = isUserQuiz ? (userSubmission?.score || 0) : null;
                    const totalQuestions = isUserQuiz ? (userSubmission?.totalQuestions || 0) : null;
                    const percentage = isUserQuiz && totalQuestions > 0
                        ? Math.round((score * 100) / (totalQuestions * 4))
                        : 0;

                    return (
                        <div key={quizNum.id || quizNum.quizNo}>


                            {isUserQuiz ? (
                                <Link to={`/quiz-details/${quizId}`} className="link"    >
                                    <div className="topic-card-mocktest-complete">
                                        <div className="topic-header quiz-score">
                                            <p style={{ color: "#c875ff", fontSize: "14px" }}>📋{index + 1}: {subjectName.length > 40 ? `${subjectName.substring(0, 38)}...` : subjectName} Mock Test</p>
                                            <p>(Y:{quizNum.year}, M:{quizNum.month}, D:{quizNum.day}, S:{quizNum.shift})</p>
                                        </div>
                                        <hr style={{ margin: "3px", }} className="hrline"></hr>
                                        <div className="quiz-score">
                                            <div className="quiz-score">
                                                <p>Score: {score} out of {totalQuestions * 4} </p>
                                                <p style={{ color: "orange" }}>{percentage}%</p>
                                            </div>
                                            <p style={{ color: "green" }}>Attempted</p>
                                        </div>
                                    </div>
                                </Link>
                            ) : (
                                <Link to={`/pyq-mock-test-start-details/${quizId}/${type}/${subject}/${subjectName}`} className="link" >
                                    <div className="topic-card">
                                        <div className="topic-header">
                                            <p style={{ color: "#c875ff", fontSize: "14px" }}> 📋 {index + 1}: {subjectName.length > 40 ? `${subjectName.substring(0, 38)}...` : subjectName} Mock Test</p>
                                            <p>(Y:{quizNum.year}, M:{quizNum.month}, D:{quizNum.day}, S:{quizNum.shift})</p>
                                        </div>
                                        <hr style={{ margin: "3px", }} className="hrline"></hr>
                                        <div className="quiz-score">
                                            <p></p>
                                            <p style={{ color: "orange", fontSize: "10px" }}>Unattempted</p>
                                        </div>
                                    </div>
                                </Link>
                            )}


                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default PYQMockTestYear;


